/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './CheckInButton.style';
import messages from 'src/shared/app/check-in/l10n/checkInTakeOverL10n';
import CheckIcon from 'src/shared/ui/component/icon/CheckIcon';

type Props = {
  handleClick: () => void,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const useStyles = createUseStyles(styles);

const CheckInButton = ({ handleClick, intl }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <a className={classes.root} href="#" onClick={handleClick}>
      <div className={classes.circle}>
        <CheckIcon className={classes.check} />
      </div>
      <div className={classes.message}>
        {intl.formatMessage(messages.checkIn)}
      </div>
    </a>
  );
};

export default compose(React.memo, injectIntl)(CheckInButton);
